import React from 'react';
import { Navigate } from 'react-router-dom';

import { Paths } from '../../../shared/paths';
import { useAccess } from '../../../hooks/useAccess';
import { ExerciseManagementInnerTabs } from './ExerciseManagementInnerTabs';

export default function ExerciseManagement() {
  const { access } = useAccess();
  const canViewSection =
    (access?.exerciseProperties?.canView ?? false) ||
    (access?.exerciseOptions?.canView ?? false) ||
    (access?.exerciseLoadFormulas?.canView ?? false);

  if (!canViewSection) {
    return <Navigate to={Paths.root} replace />;
  }

  return <ExerciseManagementInnerTabs />;
}
